import { useCallback } from "react"
import { getSubmit } from "@ui-seeker/utils"
import { useSignal } from "@preact/signals-react"
import { BACKEND_APIS } from "@constants"
import { autoEuropePricingIdDrawerData } from "Pages/AutoEuropeTool/PricingId/@signals"
import { useToast } from "@hooks"

const toAutocompleteOffice = o => ({ value: o.officeID, label: o.name, office_type: o.type, country: o.country })

export default function useAutoEuropePricingIdEdit(id) {
	const { showToast } = useToast()
	const isLoading = useSignal(false)

	const onEdit = useCallback(() => {
		isLoading.value = true
		getSubmit(`${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/pricing-id/list`, { id })
			.then(data => {
				autoEuropePricingIdDrawerData.value = {
					pricingRecordId: data.pricingRecordId,
					offices: (data.officesName ?? []).map(toAutocompleteOffice),
					market: data.market ? { value: data.market, label: data.market } : null,
					autoeuropeVsMetaId: data.autoeuropeVsMetaId ?? null,
					cr8VsMetaId: data.cr8VsMetaId ?? null,
					_isEditing: true,
				}
				isLoading.value = false
			})
			.catch(() => {
				isLoading.value = false
				showToast.error("Error loading pricing ID record")
			})
	}, [id])

	return { onEdit, isLoading: isLoading.value }
}